import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		main: {
			// ?safe&mock-data&utm_source=google&country=US&area=main&exp=web_welcome_for_search_fasting_lose_weight~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_welcome_for_search_fasting_lose_weight'),
			},
		},
	},
]

export default config
